var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffsetPrinting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c51bf056-3d14-445e-a3c2-82fa8d788428",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 46.6,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 46.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-9fcd04a3-2fce-47b5-8669-e5d7ac01d410{fill:url(#uuid-1ce2c57b-22dd-483d-a2b9-66b368565710);}.uuid-b2780a29-a755-4251-8c77-6552bcc4217c{fill:url(#uuid-fc044efa-81cd-4ffc-aa76-b44dd58e24eb);}.uuid-a87cc7cb-1814-4720-8362-5c9c6035c641{fill:url(#uuid-fa327af6-e70e-4c64-b9ea-0c8da4841b1b);}.uuid-1b06eb36-26e3-4060-a861-6c35c2ce5cc3{fill:url(#uuid-1694e186-c329-43c9-9c81-d0d76c450afd);}.uuid-4e80db58-bb15-48a2-b1cc-48355d6a5be1{fill:url(#uuid-f3fe5431-03e2-47ff-bdd3-a2a1db62ca03);}.uuid-9cec7fbb-0d0a-4db3-b84c-6b075539c752{fill:url(#uuid-5d0f68c1-70dc-493a-8d3e-a2ad6020c3c3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1694e186-c329-43c9-9c81-d0d76c450afd",
    x1: 0,
    y1: 23.3,
    x2: 76,
    y2: 23.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-fa327af6-e70e-4c64-b9ea-0c8da4841b1b",
    x1: 26,
    y1: 23.4,
    x2: 50.4,
    y2: 23.4,
    xlinkHref: "#uuid-1694e186-c329-43c9-9c81-d0d76c450afd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5d0f68c1-70dc-493a-8d3e-a2ad6020c3c3",
    x1: 32,
    y1: 34.8,
    x2: 56.5,
    y2: 34.8,
    xlinkHref: "#uuid-1694e186-c329-43c9-9c81-d0d76c450afd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-fc044efa-81cd-4ffc-aa76-b44dd58e24eb",
    x1: 29,
    y1: 29.1,
    x2: 53.4,
    y2: 29.1,
    xlinkHref: "#uuid-1694e186-c329-43c9-9c81-d0d76c450afd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1ce2c57b-22dd-483d-a2b9-66b368565710",
    x1: 4.9,
    y1: 23.6,
    x2: 10.4,
    y2: 23.6,
    xlinkHref: "#uuid-1694e186-c329-43c9-9c81-d0d76c450afd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f3fe5431-03e2-47ff-bdd3-a2a1db62ca03",
    x1: 4.9,
    y1: 8.8,
    x2: 10.4,
    y2: 8.8,
    xlinkHref: "#uuid-1694e186-c329-43c9-9c81-d0d76c450afd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-4b8969fd-c564-4590-839a-916324edc9ef"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-1b06eb36-26e3-4060-a861-6c35c2ce5cc3",
    d: "M64.4,39.8c.5.3,8.5-.1,10.1,0,2.9.3.7,2.6-.3,3.8-.9,1.1-2.6,2.7-4.1,3H28.4c-5.7-2.5-5.5-9.5-7-14.5-4.6-.4-10.1.5-14.6,0-7.6-1-9.1-11.8-2.9-15.7C-2.6,11.9-.7,1.1,7.5.4c13.5-1.2,28.5.9,42.2,0,8.3.6,10.3,11.6,3.6,15.8,2.4,1.7,4.1,4.7,5.4,7.3,2.8,5.2,4.3,10.6,5.7,16.4ZM4,13.8c6.3,5.6,13.2-5.6,6.9-10.3C4.6-1.1-1.4,9,4,13.8ZM49.9,2.3H12.8c.5,1.2,1.4,2,1.9,3.4.7,2,.8,4.3,0,6.3l-1.9,3.3h37.7c.9,0,2.9-1.4,3.5-2.2,2.9-3.9,1-10.2-4-10.8ZM6.8,17.2c-6.8,1.1-6.1,13.1,1,12.9,7.8-.2,7-14.1-1-12.9ZM20.6,30.1c-1.8-4.7-4.2-9.4-7.8-13l1.8,3.2c.9,2.1.8,4.7,0,6.8-.5,1.1-1.3,1.9-1.8,3h7.8ZM62.2,39.8c-.9-5.1-2.4-10-4.7-14.6-1-1.9-3.5-6.5-5.3-7.4-.2-.1-1.6-.7-1.7-.7H15.7l3.6,5.5c1.8,3.4,3.4,6.8,4.4,10.5.9,3.1,1.1,7.4,3.1,9.9,4.5,5.5,6.4-3.1,8.2-3.1h27.2ZM73,42h-37.4l-2,2.7h36.3c.6,0,2.7-2,3.1-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a87cc7cb-1814-4720-8362-5c9c6035c641",
    d: "M26,24.4v-1.4c.2-.4.8-.4,1.2-.5,6.8-.7,14.7.5,21.6,0,1.8,0,2.3,1.9,0,1.9h-22.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9cec7fbb-0d0a-4db3-b84c-6b075539c752",
    d: "M32.6,33.9h23.2c.8,0,.8,1.9,0,1.9h-23.2c-.6,0-1-1.6,0-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b2780a29-a755-4251-8c77-6552bcc4217c",
    d: "M29.4,30.1c-1-.3-.2-2.3,1.1-1.9,7,.5,14.8-.6,21.6,0s1.7.7.8,1.9h-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9fcd04a3-2fce-47b5-8669-e5d7ac01d410",
    d: "M7,20.7c3.2-.6,4.6,4,1.9,5.5-3.9,2.2-5.8-4.7-1.9-5.5ZM7.5,22.6c-.9.2-.9,2,0,2.1,1.3.1,1.1-2.3,0-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e80db58-bb15-48a2-b1cc-48355d6a5be1",
    d: "M7.3,5.8c2.9-.4,4.4,4.1,1.5,5.6-4,2.1-5.6-5.1-1.5-5.6ZM8.2,8c-1.3-.8-1.9,1.7-.6,1.8s1.1-1.5.6-1.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsetPrinting);
export default __webpack_public_path__ + "static/media/Offset Printing.2585553a53a4de15c1b2ff8cd5886340.svg";
export { ForwardRef as ReactComponent };